import type { z } from 'zod'

// shared min<=max validator for Zod superRefine bodies. used by both bot account
// settings and per-instrument override schemas (drop / shift percent ranges).
export function refineMinMax(
  ctx: z.RefinementCtx,
  data: Record<string, unknown>,
  minKey: string,
  maxKey: string,
  message: string
): void {
  const min = data[minKey]
  const max = data[maxKey]
  if (typeof min !== 'number' || typeof max !== 'number') return
  if (min > max) {
    ctx.addIssue({ code: 'custom', message, path: [minKey] })
  }
}
